import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const BlogCard = ({ image, date, title, category, fullText }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
        whileHover={{ y: -5 }}
        className="bg-gray-800 rounded-2xl overflow-hidden border border-gray-700 hover:border-blue-500 transition-all duration-300 shadow-lg"
      >
        <div className="relative overflow-hidden group h-48">
          <motion.img
            initial={{ scale: 1 }}
            whileHover={{ scale: 1.05 }}
            className="w-full h-full object-cover transition-transform duration-500"
            src={image}
            alt={title}
          />
        </div>

        <div className="p-6">
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs font-medium text-blue-400 bg-blue-900/30 px-2 py-1 rounded-full">
              {category}
            </span>
            <span className="text-xs text-gray-400">
              {new Date(date).toLocaleDateString("ru-RU", {
                day: "numeric",
                month: "long",
                year: "numeric",
              })}
            </span>
          </div>

          <h3 className="text-lg font-semibold text-gray-200 mb-2 leading-tight">
            {title}
          </h3>

          <div className="flex justify-end mt-4 pt-4 border-t border-gray-700">
            <button
              onClick={() => setShowModal(true)}
              className="text-sm font-medium text-blue-400 hover:text-blue-300 transition-colors"
            >
              Читать статью →
            </button>
          </div>
        </div>
      </motion.div>

      {/* Модалка */}
      <AnimatePresence>
        {showModal && (
          <motion.div
            className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center px-4"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <motion.div
              className="bg-gray-900 text-white p-8 rounded-2xl max-w-2xl w-full relative overflow-y-auto max-h-[90vh]"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <button
                onClick={() => setShowModal(false)}
                className="absolute top-4 right-4 text-gray-400 hover:text-white text-2xl"
              >
                &times;
              </button>
              <h2 className="text-2xl font-bold mb-4">{title}</h2>
              <p className="text-sm text-gray-400 mb-2">
                {new Date(date).toLocaleDateString("ru-RU", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>
              <p className="mt-4 text-gray-300 leading-relaxed whitespace-pre-line">
                {fullText}
              </p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default BlogCard;
